import Nav from "../components/Nav";
import Hero from "../components/sections/Hero";
import OurServices from "../components/sections/OurServices";
import GlobalServices from "../components/sections/GlobalServices";
import Reviews from "../components/sections/Reviews";
import BookingForm from "../components/sections/BookingForm";
import Consultation from "../components/sections/Consultation";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="relative" data-testid="home-page">
      <div className="grain" />
      <Nav />
      <main>
        <Hero />
        <OurServices />
        <GlobalServices />
        <Reviews />
        <Consultation />
        <BookingForm />
      </main>
      <Footer />
    </div>
  );
}
